import type { HTMLAttributes } from "react";
import { cn } from "../../../utils/cn";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: "outline" | "elevated";
}

export function Card({ className, variant = "outline", ...props }: CardProps) {
  const base = "rounded-md bg-surface";
  const style =
    variant === "elevated" ? "shadow-lg border border-muted/20" : "border border-muted shadow-sm";
  return <div className={cn(base, style, className)} {...props} />;
}

export function CardHeader({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("p-4 border-b border-muted/20", className)} {...props} />;
}

export function CardContent({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("p-4", className)} {...props} />;
}

export function CardFooter({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("p-4 border-t border-muted/20", className)} {...props} />;
}

export default Card;
